export const AXE_REPORTS_TEAMS_V1 = 'axe_reports_teams_v1';
